/**
 * Token references for the aggregate editor design system.
 *
 * Color values resolve through the semantic CSS custom properties defined in
 * index.css (which flip with the `.dark` class on <html>) or, for static
 * palette shades, through the generated palette in styles/figma-tokens.ts.
 */

import { palette } from '@/styles/figma-tokens';

export const TOKENS = {
  primaryMain: 'rgb(var(--color-primary))',
  primaryDark: palette.primary['700'],
  primary8: 'rgb(var(--color-primary) / 0.08)',
  primary12: 'rgb(var(--color-primary) / 0.12)',
  primary20: 'rgb(var(--color-primary) / 0.20)',
  primary24: 'rgb(var(--color-primary) / 0.24)',
  primary32: 'rgb(var(--color-primary) / 0.32)',
  primary48: 'rgb(var(--color-primary) / 0.48)',
  primaryLighter: palette.primary['200'],
  secondaryMain: 'rgb(var(--color-secondary))',
  secondary8: 'rgb(var(--color-secondary) / 0.08)',
  secondary40: 'rgb(var(--color-secondary) / 0.40)',
  textPrimary: 'rgb(var(--color-text-primary))',
  textSecondary: 'rgb(var(--color-text-secondary))',
  textDisabled: 'rgb(var(--color-text-disabled))',
  backgroundPaper: 'rgb(var(--color-surface-primary))',
  backgroundDefault: 'rgb(var(--color-background))',
  grey400: palette.grey['400'],
  grey600: palette.grey['600'],
  actionSelected: 'rgb(var(--color-action-hover) / 0.16)',
  errorMain: palette.error['500'],
  successMain: palette.success['500'],
  infoMain: 'rgb(var(--color-primary))',
  whiteMain: palette.white,
} as const;

export function uid(prefix = 'id'): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36).slice(-4)}`;
}
